function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v6.667H0v-6.667Z",
    style: {
      fill: "#f15b25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30v6.667H0v-6.667Z",
    style: {
      fill: "#006934"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3.083,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2.667,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 0.533,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.333l.1,1.605-.1.795-.1-.795.1-1.605Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.348,
    cy: 12.356,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,17.667l-.1-1.605.1-.795.1.795-.1,1.605Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.652,
    cy: 17.644,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.69,12.424l-.319,1.576-.302.742.109-.793.512-1.525Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.02,
    cy: 12.536,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31,17.576l.319-1.576.302-.742-.109.793-.512,1.525Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.98,
    cy: 17.464,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.333,12.691l-.716,1.44-.484.638.311-.738.889-1.34Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.623,
    cy: 12.884,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667,17.309l.716-1.44.484-.638-.311.738-.889,1.34Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.377,
    cy: 17.116,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.886,13.114l-1.064,1.205-.633.491.491-.633,1.206-1.063Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.116,
    cy: 13.377,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.114,16.886l1.064-1.205.633-.491-.491.633-1.206,1.063Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.884,
    cy: 16.623,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.309,13.667l-1.34.889-.738.311.638-.484,1.44-.716Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.464,
    cy: 13.979,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.691,16.333l1.34-.889.738-.311-.638.484-1.44.716Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.536,
    cy: 16.021,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.576,14.31l-1.524.512-.793.109.741-.302,1.576-.319Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.644,
    cy: 14.652,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.424,15.69l1.524-.512.793-.109-.741.302-1.576.319Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.356,
    cy: 15.348,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.667,15l-1.605.1-.795-.1.795-.1,1.605.1Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.644,
    cy: 15.348,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.333,15l1.605-.1.795.1-.795.1-1.605-.1Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.356,
    cy: 14.652,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.576,15.69l-1.576-.319-.742-.302.793.109,1.525.512Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.464,
    cy: 16.021,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.424,14.31l1.576.319.742.302-.793-.109-1.525-.512Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.536,
    cy: 13.979,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.309,16.333l-1.44-.716-.638-.484.738.311,1.34.889Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.116,
    cy: 16.623,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.691,13.667l1.44.716.638.484-.738-.311-1.34-.889Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.884,
    cy: 13.377,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.886,16.886l-1.205-1.064-.491-.633.633.491,1.063,1.206Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.623,
    cy: 17.116,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.114,13.114l1.205,1.064.491.633-.633-.491-1.063-1.206Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.377,
    cy: 12.884,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.333,17.309l-.889-1.34-.311-.738.484.638.716,1.44Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.02,
    cy: 17.464,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667,12.691l.889,1.34.311.738-.484-.638-.716-1.44Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.98,
    cy: 12.536,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.69,17.576l-.512-1.524-.109-.793.302.741.319,1.576Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.348,
    cy: 17.644,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31,12.424l.512,1.524.109.793-.302-.741-.319-1.576Z",
    style: {
      fill: "#2c2c6f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.652,
    cy: 12.356,
    r: 0.117,
    style: {
      fill: "#2c2c6f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.7aca436a8e3beb6649cbf7cde705f786.svg";
export { ForwardRef as ReactComponent };